<script setup lang="ts">
import { ref } from 'vue'

const year = ref(new Date().getFullYear())
</script>

<template>
  <!-- BEGIN #footer -->
  <div id="footer" class="py-5 bg-gray-800 text-body text-opacity-75" data-bs-theme="dark">
    <div class="container-xxl px-3 px-lg-5">
      &copy; {{ year }} Core Digital Technology All Right Reserved
    </div>
  </div>
  <!-- END #footer -->
</template>